<template>
    <BaseWidget :title="widget.title" :title-url="widget.titleUrl">
        <AppButton :href="widget.content.url" element="a" desired-action>
            {{ widget.content.text_button }}
        </AppButton>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    name: 'SingleButtonWidget',
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
    components: {
        AppButton,
        BaseWidget,
    },
};
</script>
